import { useRive, useStateMachineInput } from '@rive-app/react-canvas';
import React, { useEffect, useState } from 'react';
import AiBot from '../assets/Monica_Bot_v2.riv';
import { GLOBAL_AI_BOT_STATE } from '../helpers';

const GlobalAIBot = (props) => {
  const { riveState, stateMachine } = props;
  const [botState, setBotState] = useState(null);

  const STATE_MACHINE_NAME = stateMachine || 'Monica_Button';

  const { rive, RiveComponent } = useRive({
    autoplay: true,
    src: AiBot,
    stateMachines: STATE_MACHINE_NAME
  });

  const animations = {
    Entry: useStateMachineInput(rive, STATE_MACHINE_NAME, 'Bot_Open'),
    Exit: useStateMachineInput(rive, STATE_MACHINE_NAME, 'Exit'),
    Arrow_Entry: useStateMachineInput(rive, STATE_MACHINE_NAME, 'Arrow_Entry'),
    Bot_Entry: useStateMachineInput(rive, STATE_MACHINE_NAME, 'Bot_Entry'),
    Search: useStateMachineInput(rive, STATE_MACHINE_NAME, 'Search'),
    Idle: useStateMachineInput(rive, STATE_MACHINE_NAME, 'Ilde'),
    Happy: useStateMachineInput(rive, STATE_MACHINE_NAME, 'Happy')
  };

  const changeAnimation = (animationName) => {
    let animation = animations?.[animationName];
    if (
      animationName === GLOBAL_AI_BOT_STATE.entry &&
      botState === GLOBAL_AI_BOT_STATE.Arrow_Entry
    ) {
      animation = animations?.Bot_Entry;
    }
    if (animation) {
      animation.fire();
    }
    // if (
    //   botState === GLOBAL_AI_BOT_STATE.Arrow_Entry &&
    //   animationName === 'Exit'
    // ) {
    //   animations?.Bot_Entry?.fire();
    //   setTimeout(() => {
    //     animations?.Exit?.fire();
    //   }, 500);
    // } else if (animation) {
    //   animation.fire();
    // }
  };

  useEffect(() => {
    if (riveState && botState !== riveState) {
      const updatedAnimation = riveState;
      setBotState(updatedAnimation);
      changeAnimation(updatedAnimation);
    }
  }, [riveState]);

  const showBoxShadow = botState && botState !== 'Exit';

  const classNames = ['ai-rive-bot', showBoxShadow && 'ai-box-shadow']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames}>
      <RiveComponent />
    </div>
  );
};

export default GlobalAIBot;
